<template>
  <div class="mains">
    <div class="campus">
      习题管理
      <span>></span>习题库
    </div>
    <div class="xiaoqu moerduo">
      <el-row :gutter="24">
        <el-col :span="24">
          <div class="grid-content bg-purple scrollbarStyle" style="height: 100%; overflow: auto">

            <div class="xiaoqu_1">我的习题库</div>
            <div style="marginBottom:-10px;">
              <router-link to="/makeexercises">
                <el-button type="primary" style="marginRight:30px;">+ 新建习题</el-button>
              </router-link>

              <span class="package_type">所属系列教材:</span>
              <el-select v-model="belongTextbook" size="mini" @change="getThisBook()">
                <el-option v-for="(item) in textbookList" :key=item.id :value="item.id" :label="item.name">
                </el-option>
              </el-select>
              <el-select v-model="belongTextbookDetails" size="mini" @change="getMyTopic()">
                <el-option v-for="(item) in textbookListDetails" :key=item.id :value="item.id" :label="item.name">
                </el-option>
              </el-select>
              <span class="package_type">题包类型:</span>
              <el-select v-model="packageType" size="mini" @change="getMyTopic()">
                <el-option v-for="(item) in list" :key=item.id :value="item.value" :label="item.label"></el-option>
              </el-select>
              <span class="package_type">习题名称:</span>
              <span>
                <el-input v-model="orgnames" @keyup.13.native="getMyTopic" placeholder="请输入关键字回车查询"></el-input>
              </span>
              <span class="buttons sousuo_wjj1">
                <el-button type="primary" @click="belongTextbookDetails='';getMyTopic()">查 询</el-button>
              </span>
              <span style="color:#CCCCCC; fontSize:12px;">我的习题库是您自行创建习题包的集合库，您可对其进行新建、编辑、查看、布置班级及重新自由组题</span>
            </div>
            <div class="zsbg">
              <el-table :data="myTopic" border style="width: 100%">
                <el-table-column prop="title" label="习题包名称"></el-table-column>
                <el-table-column prop="typeStr" label="题包类别"></el-table-column>
                <el-table-column prop="shortName" label="所属教材"></el-table-column>
                <el-table-column prop="stateStr" label="状态"></el-table-column>
                <el-table-column prop="level" label="难易程度"></el-table-column>
                <el-table-column prop="createDate" label="制题时间"></el-table-column>
                <el-table-column label="操作">
                  <template slot-scope="scope">
                    <el-button type="text" @click="changeClassMessage(scope.row)">修改</el-button>
                    <el-button type="text" @click="editmyclass(scope.row)">编辑</el-button>
                    <el-button type="text" @click="previewmyclass(scope.row)">预览</el-button>
                    <el-button type="text" @click="removemyclass(scope.row)">删除</el-button>
                    <!-- <el-button type="text" @click="arrangemyclass(scope.row)">布置</el-button> -->
                  </template>
                </el-table-column>
              </el-table>

            </div>
          </div>
        </el-col>
        <!-- 分页 -->
        <div style="marginBottom:200px;">
          <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
            :page-sizes="[5, 10, 15, 20, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
          </el-pagination>
        </div>
      </el-row>
      <!-- 公共习题库 -->
      <div class="grid-content bg-purple scrollbarStyle" style="height: 100%; marginTop:10px; overflow: auto">
        <div class="xiaoqu_1">公共习题库</div>
        <div style="marginBottom:-10px;">
          <span class="package_type">所属系列教材:</span>
          <el-select v-model="belongTextbooks" size="mini" @change="getThisBooks()">
            <el-option v-for="(item) in textbookLists" :key=item.id :value="item.id" :label="item.name">
            </el-option>
          </el-select>
          <el-select v-model="belongTextbookDetailss" size="mini" @change="getPublicTopic()">
            <el-option v-for="(item) in textbookListDetailss" :key=item.id :value="item.id" :label="item.name">
            </el-option>
          </el-select>
          <span class="package_type" style="marginLeft:520px;">习题名称:</span>
          <span>
            <el-input v-model="orgnamess" @keyup.13.native="getPublicTopic" placeholder="请输入素材关键字进行查找"></el-input>
          </span>
          <span class="buttons sousuo_wjj1">
            <el-button type="primary" @click="belongTextbookDetailss='';getPublicTopic()">查 询</el-button>
          </span>
        </div>
        <div class="zsbg">
          <el-table :data="publicTopic" border style="width: 100%">
            <el-table-column prop="title" label="习题包名称"></el-table-column>
            <el-table-column prop="shortName" label="所属教材"></el-table-column>
            <el-table-column prop="level" label="难易程度"></el-table-column>
            <el-table-column prop="createDate" label="制题时间"></el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button type="text" @click="previewmyclass(scope.row)">预览</el-button>
                <!-- <el-button type="text">布置</el-button> -->
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <el-pagination background @size-change="handleSizeChanges" @current-change="handleCurrentChanges" :current-page="currentPages"
        :page-sizes="[1, 2, 3, 5, 10]" :page-size="pageSizes" layout="total, sizes, prev, pager, next, jumper" :total="totals">
      </el-pagination>
    </div>
    <el-dialog title="查看习题" :visible.sync="preview" width="60%">
      <div class="dialog_title">{{title}}</div>
      <div class="dialog_message">习题数：{{number}} 大题 <span>制作人: {{creatorName}} 老师</span> <span>习题难度: {{level}}</span></div>
      <div class="exercise">
        <div v-for="(item, index) in questionGroup" :key="index" style="borderBottom: 1px solid #cccccc; marginBottom:10px;">
          <div class="exerciseNumber">{{ item.title}} <span class="number_score">(共{{item.questionCount}}小题,共{{item.totalScore}}分)</span>
          </div>
          <div v-for="(items, index) in item.questions" :key="index">
            <div class="small_title" style="white-space:pre-line"><span>{{items.order}}、{{items.text}}</span></div>
            <p style="margin:20px 30px;fontSize:14px; lineHeight:30px; white-space:pre-line">{{items.questionStr}}</p>
            <div class="images" v-show="items.img"><img :src="items.img" alt=""></div>
            <div v-for="(itemss, index) in items.questions" :key="index">
              <p style="margin:20px 20px;white-space:pre-line">{{itemss.text}}</p>
              <div style="margin:20px 30px;" class="images" v-show="itemss.img"><img :src="itemss.img" alt=""></div>
              <div v-for="(itemsss, index) in itemss.options" :key="index">
                <div style="margin:20px 30px;">{{itemsss.label}}: {{itemsss.content}}</div>
                <div style="margin:20px 30px;" class="images" v-show="itemsss.img"><img :src="itemsss.img" alt=""></div>
              </div>
            </div>
            <div style="margin:20px 30px; white-space:pre-line;" v-if="items.optionsStr">{{items.optionsStr}}</div>
            <div v-else v-for="(itemss, index) in items.options" :key="index">
              <div style="margin:20px 30px; ">{{itemss.label}} : {{itemss.content}}</div>
              <div class="images" v-show="itemss.img"><img :src="itemss.img" alt=""></div>
            </div>
            <div style="margin:20px 30px;"><span
                style="display:inlineBlock; white-space:pre-line; lineHeight:20px; marginRight:30px;">{{items.spaces}}</span></div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="preview = false">取 消</el-button>
        <el-button type="primary" @click="preview = false">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
export default {
  name: 'schoolbook',
  data() {
    return {
      myTopic: [],
      value: [],
      littleNodeList: [],
      publicTopic: [],
      list: [
        { value: '', label: '全部' },
        { value: 'SELF-BUILT', label: '自建题包' },
        { value: 'RESTRUCTURE', label: '重组题包' },
      ],
      textbookList: [],
      textbookLists: [],
      textbookListDetails: [],
      textbookListDetailss: [],
      belongTextbook: '',
      belongTextbooks: '',
      belongTextbookDetails: '',
      belongTextbookDetailss: '',
      title: '',
      number: '',
      creatorName: '',
      level: '',
      questionGroup: [],
      exerciseNumber: '',
      preview: false,
      total: 0,
      pageSize: 5,
      pageSizes: 5,
      currentPage: 1,
      totals: 0,
      page: '',
      pages: '',
      currentPages: 1,
      packageType: '',
      orgnames: '',
      orgnamess: '',
    };
  },
  created() {
    this.getMyTopic();
    this.getPublicTopic();
    this.referOrganzationList();
    this.referOrganzationLists();
  },
  methods: {
    handleChange(value) {
      console.log(value);
      this.littleNode = value[0] + '-' + value[1];
    },
    //获取机构类表
    referOrganzationList() {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let orgid = window.sessionStorage.getItem('orgid');
      // console.log(this.miniid,"111");
      let pro = this.$http({
        url: '/edu/book/getGroupList/' + orgid,
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro.then((res) => {
        console.log(res, '查询机构');
        if (res.data.code === 0) {
          this.textbookList = res.data.data;
        }
      });
    },
    //获取机构类表
    referOrganzationLists() {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let orgid = window.sessionStorage.getItem('orgid');
      // console.log(this.miniid,"111");
      let pro = this.$http({
        url: '/edu/book/getGroupList/' + orgid,
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro.then((res) => {
        console.log(res, '查询机构');
        if (res.data.code === 0) {
          this.textbookLists = res.data.data;
        }
      });
    },
    //获取图书列表
    getThisBook() {
      console.log(this.belongTextbook);
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let orgid = window.sessionStorage.getItem('orgid');
      let pro = this.$http({
        url: '/edu/book/books/' + orgid + '/' + this.belongTextbook,
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro.then((res) => {
        console.log(res, '查询了机构');
        if (res.data.code === 0) {
          this.textbookListDetails = res.data.data;
          console.log(this.belongTextbookDetails);
        }
      });
    },
    //获取图书列表2
    getThisBooks() {
      console.log(this.belongTextbooks);
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let orgid = window.sessionStorage.getItem('orgid');
      let pro = this.$http({
        url: '/edu/book/books/' + orgid + '/' + this.belongTextbooks,
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro.then((res) => {
        console.log(res, '查询了机构');
        if (res.data.code === 0) {
          this.textbookListDetailss = res.data.data;
          console.log(this.textbookListDetailss);
        }
      });
    },
    //修改习题包信息
    changeClassMessage(row) {
      this.$router.push({ path: 'makeexercises', query: row });
    },
    //获取我的习题包
    getMyTopic() {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let orgid = window.sessionStorage.getItem('orgid');
      let pro = this.$http({
        url: '/edu/exercise-pack/myself',
        params: {
          bookId: this.belongTextbookDetails,
          title: this.orgnames,
          type: this.packageType,
          page: this.page,
          pageSize: this.pageSize,
        },
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro.then((res) => {
        console.log(res);
        this.orgnames = '';
        // this.belongTextbookDetails = '';
        res.data.data.forEach((item) => {
          if (item.level < 1) {
            item.level = '易';
          }
          if (item.level == 1) {
            item.level = '中';
          }
          if (item.level > 1) {
            item.level = '难';
          }
        });
        this.myTopic = res.data.data;
        this.total = res.data.size;
      });
    },
    //获取公共习题包
    getPublicTopic() {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let orgid = window.sessionStorage.getItem('orgid');
      let pro = this.$http({
        url: '/edu/exercise-pack/pubilc',
        params: {
          bookId: this.belongTextbookDetailss,
          title: this.orgnamess,
          page: this.pages,
          pageSizes: this.pageSizes,
        },
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro.then((res) => {
        this.orgnames = '';
        // this.belongTextbookDetails = '';
        res.data.data.forEach((item) => {
          if (item.level < 1) {
            item.level = '易';
          }
          if (item.level == 1) {
            item.level = '中';
          }
          if (item.level > 1) {
            item.level = '难';
          }
        });
        this.publicTopic = res.data.data;
        this.totals = res.data.size;
      });
    },
    //删除我的习题
    removemyclass(row) {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let orgid = window.sessionStorage.getItem('orgid');
      this.$confirm('确认要删除吗?', '删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        let pro = this.$http({
          url: '/edu/exercise-pack/' + row.id + '/del',
          method: 'POST',
          headers: {
            Authorization: 'Bearer ' + token,
          },
        });
        pro.then((res) => {
          if (res.data.code === 0) {
            this.getMyTopic();
            this.$message.success('删除成功！');
          } else {
            this.$message.error(res.data.message);
          }
        });
      });
    },
    //编辑我的习题
    editmyclass(row) {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let orgid = window.sessionStorage.getItem('orgid');
      let pro = this.$http({
        url: '/edu/exercise-pack/upd/' + row.id,
        method: 'POST',
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro.then((res) => {
        if (res.data.code === 0) {
          this.$router.push({ path: 'bigquestionlist', query: { id: row.id, bookid: row.bookId, littleNode: row.section } });
        }
      });
    },
    //预览我的习题包
    previewmyclass(row) {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let orgid = window.sessionStorage.getItem('orgid');
      let pro = this.$http({
        url: '/edu/exercise-pack/' + row.id + '/questions/detail',
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro.then((res) => {
        if (res.data.code === 0) {
          console.log(res);
          if (res.data.data.level < 1) {
            res.data.data.level = '易';
          }
          if (res.data.data.level == 1) {
            res.data.data.level = '中';
          }
          if (res.data.data.level > 1) {
            res.data.data.level = '难';
          }
          let data = res.data.data;
          this.title = data.title;
          this.number = data.questionGroup.length;
          this.creatorName = data.creatorName;
          this.level = data.level;
          this.questionGroup = data.questionGroup;
        }
      });
      this.preview = true;
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.page = 1;
      this.currentPage = 1;
      this.getMyTopic();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getMyTopic();
    },
    handleSizeChanges(val) {
      this.pageSizes = val;
      this.pages = 1;
      this.currentPages = 1;
      this.getPublicTopic();
    },
    handleCurrentChanges(val) {
      this.pages = val;
      this.getPublicTopic();
    },
  },
};
</script>

<style lang="less" scoped>  
.clear {
  clear: both;
}
.el-input {
  width: 200px;
  height: 30px;
  margin-right: 20px;
}
.dialog_message {
  text-align: center;
  margin-top: 10px;
  margin-bottom: 40px;
  color: #666666;
  line-height: 13px;
  :first-child {
    display: inline-block;
    margin: 0 50px;
    overflow: hidden;
  }
  :nth-child(2) {
    display: inline-block;
    margin: 0 50px;
  }
}
.exercise {
  padding: 0 120px 0 20px;
  .exerciseNumber {
    font-size: 16px;
    font-weight: 700;
    margin-bottom: 10px;
    color: #333333;
  }
  .number_score {
    display: inline-block;
    padding-left: 20px;
    font-size: 12px;
    font-weight: normal;
    color: #999999;
  }
  .small_title {
    margin-left: 10px;
    color: #333333;
    font-weight: 550;
    line-height: 30px;
    padding: 20px 0;
  }
  .images {
    width: 120px;
    height: 100%;
    border: 1px dotted #cccccc;
    img {
      width: 100%;
    }
  }
}
.el-pagination__editor.el-input .el-input__inner {
  width: 25px !important;
}
.el-input {
  width: 241px;
}
.mains .xiaoqu .grid-content .tj_jc {
  .quanbu_jc {
    .el-form-item__content {
      margin-left: 0 !important;
    }
  }
  .el-dialog {
    width: 1300px !important;
    height: 850px;
    top: 50%;
  }
  .el-dialog__header {
    width: 1240px !important;
    .el-dialog__title {
      font-size: 22px;
      padding-left: 28px;
    }
    .el-dialog__title:before {
      height: 22px;
      top: 26px;
      left: 40px;
    }
    .el-dialog__headerbtn {
      right: 40px;
    }
  }
  .jc_11 {
    float: left;
    margin-left: 185px;
    font-size: 18px;
  }
  .jc_fl {
    float: left;
    font-size: 20px;
    color: #333;
    font-weight: bold;
    margin-left: 28px;
  }
  .jc_22 {
    clear: both;
    margin-left: -10px;
    .quanbujiaocai {
      margin-top: 15px;
      float: left;
      div {
        width: 212px;
        height: 50px;
        line-height: 50px;
        font-size: 18px;
        color: #999;
        background: #efefef;
        border-radius: 5px;
        margin: 10px 0 0 0;
        padding-left: 28px;
      }
      div:hover {
        color: #fff;
        background: #00a6e6;
      }
      .quanbujiaocai_2 {
        color: #fff;
        background: #00a6e6;
      }
    }

    .jiao_tu {
      margin-left: 260px !important;
      .jiaocai_zi {
        height: 30px;
      }
      .fenye_1 {
        margin: 0 !important;
      }
    }

    .jiaocai {
      margin: 30px 0px 0 30px !important;
      .jiaocai_tu {
        width: 162px !important;
        height: 206px !important;
        img {
          width: 150px !important;
          height: 190px !important;
          margin: 13px 0 0 -4px;
        }
        .zuoshangjiao {
          position: absolute;
          top: -8px;
          left: -5px;
          width: 50px !important;
          height: 25px !important;
          z-index: 999 !important;
        }
        .youxiajiao {
          position: absolute;
          right: -3px;
          bottom: 4px;
          width: 48px !important;
          height: 18px !important;
        }
      }
      .jiaocai_zi {
        width: 162px;
      }
      .jiaocai_tu {
        .is-checked {
          .el-checkbox__input {
            background: none !important;
          }
        }
      }
      .el-checkbox {
        position: absolute;
        // top: -14px;
        // right: -6px;
        z-index: 9999;
        .el-checkbox__input {
          width: 22px;
          height: 22px;
          float: right;
          background: url(../../../assets/img/textbook-manage/schoolbook/weixuan.png) no-repeat !important;
          background-size: 22px 22px !important;
          .el-checkbox__inner {
            width: 0;
            height: 0;
            border: none;
          }
          .el-checkbox__inner::after {
            width: 22px;
            height: 22px;
            top: -12px;
            left: 0px;
            border: none;
            background: url(../../../assets/img/textbook-manage/schoolbook/xuanzhong.png) !important;
            background-size: 22px 22px !important;
          }
          input {
            width: 0;
          }
        }
        .el-checkbox__input.is-checked .el-checkbox__inner::after {
          transform: none;
        }
      }
    }
  }
  .form_1_1 {
    .jiaocai_queding {
      margin-top: 15px;
      .el-form-item__content {
        margin-left: 216px !important;
      }
      .el-button--primary {
        width: 240px;
        height: 44px;
        border-radius: 34px;
        background: #0094ce;
        font-size: 20px;
      }
      .el-button--primary:hover {
        background: #0094ce;
      }
      .el-button--default {
        width: 240px;
        height: 44px;
        border-radius: 34px;
        background: rgba(242, 242, 242, 0.8);
        border: none;
        box-shadow: 2px 2px 6px rgba(234, 234, 234, 0.3);
      }
    }
  }
}
.package_type {
  display: inline-block;
  margin-left: 20px;
  margin-right: 20px;
}
.wjj_mc {
  .el-form-item__label {
    padding: 0 !important;
    margin-left: 5px;
  }
  .el-form-item__content {
    margin-left: 140px !important;
  }
  .wuzi {
    left: -125px !important;
  }
}
.dialog_title {
  text-align: center;
  color: #00a6e6;
  font-size: 18px;
  font-weight: 500;
}
</style>
